export default {
  page: {
    upc: 'UPC',
    standardPrice: '杰西卡的标准价格',
    minPrice: '全球最低价',
    maxPrice: '全球最高价',
    exportProductData: '导出商品数据',
    searchPlaceHolder: '输入搜索条件',
    clearancePrice: '结算价格', // TODO clearancePrice: 'Clearance Price',
    discount: '折扣',
    taxfreePrice: '免税价',
    viewPriceTrend: '历史价格',
    expandAll: '全部展开',
    collapseAll: '全部折叠',
    // 一级表格字段
    tableColumns: {
      shopName: '对比商城名称',
      retailPrice: '店面价',
      cur: '货币',
      retp: '原价({0})',
      optp: '最优价({0})',
      promoRate: '活动折扣率',
      differenceTo: '差异({0})',
      indexTo: '指数({0})',
      priceGrading: '价格评分',
      status: '商品状态',
    },
    // 二级展开表格字段
    comparesTableColumns: {
      retailPrice: '店面价',
      cur: '货币',
      retp: '原价({0})',
      optp: '最优价({0})',
      status: '商品状态',
      code: 'Code',
    },
    // 图表
    charts: {
      avgPrice: '起始价格',
    },

    // 提示
    tips: {
      notParams: '{0}参数错误',
    },
  },
  priceTrend: {
    title: '历史价格',
    monntoredShop: '监测商店',
    favoriteShop: '主商城',
    subText: '确认',
    cancelText: '取消',
    noDataMsg: '所选店铺不提供此价格类型，请选择其他价格类型',
    chartTable: {
      name: '名称',
      price: '价格',
      difference: '差异',
      differenceRatio: '差异比例',
    },
    selectShopMoadl: {
      title: '监测商店',
      label: '对比商城',
      subText: '确认',
      cancleText: '取消',
    },
    priceBox: '全部价格',
    priceType: '价格类型',
    offlinePrice: '线下价格',
    onSalePrice: '优惠价格',
    priceAfterBestDiscount: '最佳折扣价格',
    original: '原价',
    retailerDisPrice: '零售商折扣价格',
    state: {
      all: '全部',
      onShelf: '上架',
      offShelf: '下架',
      sellOut: '售罄',
      productStatus: '商品状态',
    },
    showMsg: {
      title_0: '零售价',
      txt_0: '零售商网站上显示的原价。',
      title_1: '最佳折扣后的价格',
      txt_1: '网站上显示的最高折扣后的最佳价格和外部折扣。',
      title_2: '销售价格',
      txt_2: '零售商提供的折扣价。',
      title_3: '零售商折扣',
      txt_3: '折扣之上的价格基于零售价或折扣之上的估计实际价格。',
      title_4: '线下价格',
      txt_4: '仅适用于韩国零售商。',
      title_6: '清仓价格',
      txt_6: '如果有近过期产品的价格，点击只显示近过期产品的价格。如果没有近过期产品，则显示正常产品的价格。',
      title_5: '免税价格',
      txt_5: `勾选以显示退税后的价格（仅适用于已纳税的零售商。）对于北美零售商，选择此价格类型以显示其网站上显示的价格。
      对于日本零售商，选择此价格类型以显示网站上显示的价格减去退税。`,
    },
  },
  export: {
    priceSavingScale: '价格节省范围',
    priceCategory: '价格分类',
    date: '日期',
    priceList: {
      max: '最大值',
      min: '最小值',
      avg: '平均值',
    },
    table: {
      statusSoldOut: '售罄',
      statusLaunched: '在售',
      statusRemoved: '下架',
      shopName: '店铺名称',
      cur: '货币',
      retailPrice: '原价',
      retp: '原价({0})',
      promoRate: '折扣比例',
      optp: '折扣价({0})',
      indexTo: '指数{0}',
      shopNameCurrency: '{0} DF ({1})',
      savingTR: '保存TR和{0}',
      grading: '价格评分',
      status: '状态',
    },
  },
  //
  helpInfo: {
    help: '杰西卡的标准价格是杰西卡的标准商店中产品的价格。',
    shop: '标准商城：',
    firstDesc:
      '标准商城是一个基于杰西卡的秘密数据库的虚拟商城。标准商城代表了世界上大多数商城的产品选择以及这些产品的平均价格。',
    secondDesc: '1.产品选择原则',
    thirdDesc:
      '从杰西卡的秘密数据库覆盖的所有现有商城中，与3家以上商城相关并在不少于2个国家销售的产品将包含在标准商城中。',
    fourDesc: '2.定价原则',
    fiveDesc: '根据第1项（产品选择原则）选择的产品，将根据商店提供的所有现有价格计算其平均价格。',
  },
};
